import React, { useEffect, useState } from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Fab, Box } from '@mui/material';

const WhatsAppButton = () => {
  const phoneNumber = '51973863957';
  const message = '¡Hola! Quisiera obtener más información sobre los Destinos Turísticos.';
  const BASE_BOTTOM = 5; // posición normal
  const [bottom, setBottom] = useState(BASE_BOTTOM);

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  useEffect(() => {
    const footer = document.querySelector('footer');
    if (!footer) return;

    const handleScroll = () => {
      const footerRect = footer.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // cuánto espacio hay entre viewport y footer
      const overlap = viewportHeight - footerRect.top;

      if (overlap > 0) {
        setBottom(overlap + 10); // se detiene justo encima
      } else {
        setBottom(BASE_BOTTOM);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // inicial

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom,
        left: 16,
        zIndex: 1000,
        transition: 'bottom 0.2s ease-out',
      }}
    >
      <Fab
        variant="extended"
        onClick={handleClick}
        sx={{
          backgroundColor: '#25D366',
          color: 'white',
          textTransform: 'none',
          fontWeight: 'bold',
          px: 2,
          '&:hover': {
            backgroundColor: '#1ebe57',
          },
        }}
      >
        <WhatsAppIcon sx={{ mr: 1, fontSize: 28 }} />
        Contáctenos
      </Fab>
    </Box>
  );
};

export default WhatsAppButton;
